// extracted by mini-css-extract-plugin
export default {"container":"Tab_container__w+Fpv","typo":"Tab_typo__6zQ2U","tab":"Tab_tab__FudpZ"};